export default {
  orsDictionary: {
    unknown: 'Necunoscut',
    paved: 'Asfaltat',
    unpaved: 'Neasfaltat',
    asphalt: 'Asfalt',
    concrete: 'Beton',
    cobblestone: 'Pavaj',
    metal: 'metal',
    wood: 'Lemn',
    destination: 'Destinație',
    private: 'Privat',
    permissive: 'Permisivitate',
    permit: 'Permis',
    road: 'Drumul',
    street: 'Strada',
    path: 'Calea',
    track: 'Pista',
    cycleway: 'Pistă de biciclete',
    footway: 'Trotuare',
    steps: 'Pași',
    ferry: 'Feribot',
    construction: 'Construcții',
    'concrete:lanes': 'benzi de beton',
    paving_stones: 'pietre de pavaj',
    sett: 'Setare',
    compacted: 'Compactat',
    fine_gravel: 'Pietriș fin',
    pebblestone: 'Pavaj',
    impassable: 'Impasibil',
    very_horrible: 'Foarte oribil',
    customers: 'Clienți',
    delivery: 'Livrare',
    stateRoad: 'Drum national',
    unhewn_cobblestone: 'Pavaj neșlefuit',
    gravel: 'Pietriș',
    ground: 'Sol',
    pavingStones: 'Pietre de pavaj',
    sand: 'Nisip',
    woodchips: 'Așchii de lemn',
    grass: 'Iarbă',
    none: 'Nici unul',
    no: 'Nu',
    bad: 'Rău',
    intermediate: 'Intermediar',
    good: 'Bun',
    excellent: 'Excelent',
    grade1: 'Grad 1',
    grade2: 'Grad 2',
    grade3: 'Grad 3',
    grade4: 'Grad 4',
    grade5: 'Grad 5',
    is_tollway: 'Este o autostradă cu taxă',
    highway: 'Autostradă',
    unpaved_road: 'Drum neasfaltat',
    tunnel: 'Tunel',
    paved_road: 'Drum asfaltat',
    ford: 'Ford',
    no_data: 'Fără date',
    compactedGravel: 'Pietriș compactat',
    fineGravel: 'Pietriș fin',
    dirt: 'Murdărie',
    ice: 'Gheață',
    grassPaver: 'Pavele de iarbă',
    horrible: 'Oribil',
    very_bad: 'Foarte rău',
    no_tollway: 'Fără taxă de drum',
    no_category: 'Fără categorie',
  }
}
